import React from 'react';
import { View, ScrollView } from 'react-native';
import moment from 'moment';
import { createStyleSheet } from '../../utils';
import { useStyleSheet } from '../../hooks';
import { Day } from './components';
import { Divider } from '../Divider';
export { useAvailabilityEditorContext } from './hooks';
export { Picker } from './components';
export { AvailabilityEditorContextProvider } from './contexts';
const days = moment.weekdays();
export const AvailabilityEditor = ({ style }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(ScrollView, { showsVerticalScrollIndicator: false, contentContainerStyle: styles.contentContainer }, days.map((day, index, arr) => (React.createElement(React.Fragment, { key: index },
            React.createElement(Day, { key: day, name: day, day: index }),
            arr[index + 1] && (React.createElement(Divider, { type: 'horizontal', style: styles.divider }))))))));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: { flex: 1 },
    contentContainer: {},
    divider: {
        marginRight: 0,
        marginLeft: size.J + 2 * size.C,
        marginVertical: size.G
    }
}));
//# sourceMappingURL=index.js.map